export function landQuadCorners<T>(
  southWest: T,
  southEast: T,
  northEast: T,
  northWest: T,
): [T, T, T, T] {
  return [southWest, northWest, northEast, southEast];
}

export function triangleNormalY(
  ax: number,
  _ay: number,
  az: number,
  bx: number,
  _by: number,
  bz: number,
  cx: number,
  _cy: number,
  cz: number,
) {
  const abx = bx - ax;
  const abz = bz - az;
  const acx = cx - ax;
  const acz = cz - az;
  return abz * acx - abx * acz;
}
